const getPaginationPath = (itemsPerPage, ignore) => `${itemsPerPage}${ignore ? `/${ignore}` : ''}`;

const getAllForManagerPath = ({
    cddManagedIds,
    entityId,
    ignore,
    itemsPerPage,
    managedIds,
    search,
    sortColumn,
    sortOrder,
    status,
    userId,
}) => {
    const paginationPath = getPaginationPath(itemsPerPage, ignore);

    if (search && 0 < search.length) {
        if ('cdd' === status && cddManagedIds) {
            return `/api/rips/recherche/cdd-entity-manager/${entityId}/${userId}/${search}/${sortColumn}/${sortOrder}/${paginationPath}`;
        }

        if ('dcr' === status && managedIds) {
            return `/api/rips/recherche/dcr-managed/${userId}/${managedIds}/${search}/${sortColumn}/${sortOrder}/${paginationPath}`;
        }

        return `/api/rips/recherche/entity-manager/${managedIds}/${search}/${sortColumn}/${sortOrder}/${paginationPath}`;
    }

    if ('cdd' === status && cddManagedIds) {
        return `/api/rips/cdd-entity-manager/${entityId}/${userId}/${sortColumn}/${sortOrder}/${paginationPath}`;
    }

    return `/api/rips/entity-manager/${userId}/${managedIds}/${sortColumn}/${sortOrder}/${paginationPath}`;
};

export default getAllForManagerPath;
